import { createFileRoute } from '@tanstack/react-router'
import { IdentityInfoTab } from '@/components/identities/identity-tabs'

export const Route = createFileRoute('/o/$org/identities/$id/')({
  component: () => <IdentityInfoTab identityId={Route.useParams().id} />,
})
